// extracted by mini-css-extract-plugin
module.exports =  {"root":"twrDJgXUKBpoP17AVNAA","mediaCreditBalance":"jiyMe8fwVzD8PgynqO3P","marginBuster":"JfbjVBynSxZlwB84mdAG","bigNumber":"QiF9ZqmwLz7eVWMhWicN"};